// /**
//  * Product - Add
//  */

// React
import React from 'react';

// react hook form
import {useForm} from 'react-hook-form';

// UI
import {} from '@material-ui/core/styles';
import {TextField, Grid, Button, Typography} from '@material-ui/core';

// Type
import {Product} from '../interfaces';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import RonadIcons from '../../../components/iconComponent';

type Props = {
  create: (body: {code: any; name: any; partnerId: number}) => void;
  partnerId: number;
};

type Inputs = {
  name: string;
  code: string;
};

 // Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorText: {
      fontSize: '0.875rem'
    },
  })
);


export default function Add(props: Props) {
  const {register, handleSubmit, errors} = useForm<Inputs>();

  const classes = useStyles();

  const onSubmit = (data: any) => {
    const {partnerId} = props;

    const {name, code} = data;

    props.create({
      name,
      code,
      partnerId,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={5} alignItems="flex-end">
        <Grid container item xs={6} spacing={1} alignItems="flex-end">
          <Grid container item alignItems="flex-end" xs={12}>
            <Grid item xs={1}>
              <RonadIcons name='user' size={1} />
            </Grid>
            <Grid item xs={11}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="نام محصول"
                inputRef={register({
                  required: true,
                  minLength: 2,
                  maxLength: 50,
                })}
                error={errors.name && true}
              />
              {errors.name && (
                <Typography className={classes.errorText} color='error' component='span'>نام محصول را صحیح وارد نمایید</Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container item xs={6} spacing={1} alignItems="flex-end">
          <Grid container item alignItems="flex-end" xs={12}>
            <Grid item xs={1}>
              <RonadIcons name='lable' className='text-white' size={1} />
            </Grid>
            <Grid item xs={11}>
              <TextField
                fullWidth
                id="code"
                name="code"
                label="کد محصول"
                inputRef={register({
                  pattern: /^\S*$/,
                  required: true,
                  minLength: 1,
                  maxLength: 50,
                })}
                error={errors.code && true}
              />
              {errors.code && (
                <Typography className={classes.errorText} color='error' component='span'>شناسه محصول را صحیح وارد نمایید</Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={4}
          spacing={1}
          alignItems="flex-end"
          style={{marginTop: 'auto', marginRight: 'auto'}}
        >
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            size="large"
            data-cy="search"
          >
            {`ایجاد محصول جدید`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
